<template>
  <div class="ko-hourly-values">

    <div class="v-ttip" id="v-ttip"  ref="ttip" :style="ttipStyle">
      <div v-if="tooltipErrorMsg !== null" class="error"> {{ tooltipErrorMsg }}</div>
      <template v-if="isTooltipLoading">
        <img style="vertical-align: middle" :src="loadingUrl" alt=""> {{ $t('loading') }} ...
      </template>
      <template v-else>
        <KoChart chart-type="tooltip" :chart-data="$options.cachedFetch[lastTooltipParams.station_id]" :station-id-for-chart="lastTooltipParams.station_id" :selected-pollutant-id="lastTooltipParams.pollutant_id" />
      </template>
    </div>

    <div v-if="errorMsg !== null" class="error"> {{ errorMsg }}</div>
    <div class="text-center p-3" style="z-index: 100" v-if="isLoading"><img style="vertical-align: middle" :src="loadingUrl"> {{ $t('loading') }} ...</div>
    <div v-if="smogListDataLoaded && smogListData.length > 0">

      <form action="?">
        <div class="d-flex justify-content-center">
          <label class="w150 tr fl" for="selectDate">{{ $t('ko.dt_merania') }}:</label>

          <select class="w150 fl" id="selectDate"  v-model="selectedDate">
            <option v-for="date in listOfDates" :value="date.key">{{ date.name }}</option>
          </select>

          <div class="mx-3 mt-1">
            <button type="button" title="Prvý termín" @click="firstDt()" :disabled="this.selectedDate === this.min_dt" class="button w50 button-icon-only"><i class="icon-skip_previous"></i></button>
            <button type="button" title="Predchádzajúci termín" @click="prevDt()" :disabled="this.selectedDate === this.min_dt" class="button w50 button-icon-only"><i class="icon-navigate_before"></i></button>
            <button type="button" title="Nasledujúci termín" @click="nextDt()" :disabled="this.selectedDate === this.max_dt" class="button w50 button-icon-only"><i class="icon-navigate_next"></i></button>
            <button type="button" title="Posledný termín" @click="lastDt()" :disabled="this.selectedDate === this.max_dt" class="button w50 button-icon-only"><i class="icon-skip_next"></i></button>
          </div>

        </div>
        <div class="clearfix"></div>
      </form>



      <table class="dynamictable w-small-width-max center sticky-header dataTable" v-on:mouseleave="hideTooltip()">
        <caption>Stanice SHMÚ</caption>
        <thead>
        <tr>
          <th :class="sorted('station_name')">
            <a href="#!" @click="do_sort('station_name')" class="d-block text-decoration-none">
              Stanica
            </a>
          </th>
          <th v-for="item in smogListSHMUPollutants" :key="item.pollutant_id" :class="`text-center ` +  sorted(item.pollutant_id)">
            <a href="#!" @click="do_sort(item.pollutant_id)" class="d-block text-decoration-none">
              <span v-html="replacePollutantDesc(item.pollutant_desc)"></span>
            </a>

          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in smogListDataSHMUSorted" :key="item.station_id">
          <td class="w200 text-left" v-on:mouseover="hideTooltip()">{{ item.station_name }}</td>
          <td v-for="sub_item in smogListSHMUPollutants" :key="`${item.station_id}-${sub_item.pollutant_id}`"
              :class="'w50 text-center ko_oko_'+getSmogLimitLevelSHMU(item.station_id, sub_item.pollutant_id)"
              v-on:mouseenter="isOver = true; showTooltipDebounced({ station_id: item.station_id, pollutant_id: sub_item.pollutant_id })"
              v-on:mouseleave="hideTooltip()"
              :ref="`b_` + item.station_id + `_` + sub_item.pollutant_id"
              class="text-center">
            {{ getSmogValueSHMU(item.station_id, sub_item.pollutant_id) }}
          </td>
        </tr>
        </tbody>

      </table>

      <table class="dynamictable w-small-width-max center sticky-header"  v-on:mouseleave="hideTooltip()">
        <caption>Stanice ostatných prevádzkovateľov</caption>
        <thead>
        <tr>
          <th>
            <a href="#!" @click="do_sort_others('station_name')" class="d-block text-decoration-none">
              Stanica <span v-html="sorted_others('station_name')"></span>
            </a>
          </th>
          <th v-for="item in smogListOthersPollutants" :key="item.pollutant_id" class="text-center">
            <a href="#!" @click="do_sort_others(item.pollutant_id)" class="d-block text-decoration-none">
              <span v-html="replacePollutantDesc(item.pollutant_desc)"></span>
              <span v-html="sorted_others(item.pollutant_desc)"></span>
            </a>

          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in smogListDataOthersSorted" :key="item.station_id">
          <td class="w200 text-left" v-on:mouseover="hideTooltip()">{{ item.station_name }}</td>
          <td v-for="sub_item in smogListOthersPollutants" :key="`${item.station_id}-${sub_item.pollutant_id}`"
              :class="'w50 text-center ko_oko_'+getSmogLimitLevelOther(item.station_id, sub_item.pollutant_id)"
              v-on:mouseenter="isOver = true; showTooltipDebounced({ station_id: item.station_id, pollutant_id: sub_item.pollutant_id })"
              v-on:mouseleave="hideTooltip({ station_id: item.station_id, pollutant_id: sub_item.pollutant_id })"
              :ref="`b_` + item.station_id + `_` + sub_item.pollutant_id"
              class="text-center">
            {{ getSmogValueOthers(item.station_id, sub_item.pollutant_id) }}
          </td>
        </tr>
        </tbody>

      </table>


    </div>


  </div>
</template>

<script>

import SHMUconf from '../../shmu_conf';
import Axios from "axios";
import _ from 'lodash'
import KoChart from "../../components/KoChart.vue";

export default {
  name: 'KoHourlyValues',
  components: {KoChart},
  cachedFetch: [],
  data() {
    return {
      smogListData: [],
      smogListDataLoaded: false,
      selectedDate: null,
      errorMsg: null,
      tooltipErrorMsg: null,
      isError: false,
      isLoading: false,
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
      sortBy: 'poradie',
      sortDir: 1,
      sortOhtersBy: 'poradie',
      sortOthersDir: 1,

      tooltipShow: false,
      lastTooltipParams: {},
      oLeft: -10000,
      oTop: -1000,
      isTooltipLoading: true,
      isOver: false,

    }
  },
  watch: {
    smogListData() {
      if (this.smogListData && this.smogListData.length > 0) {
        this.selectedDate = this.max_dt;
      }
    },
  },
  mounted() {
    this.loadSmogListData();
    document.body.appendChild(document.getElementById('v-ttip'));

  },
  computed: {
    listOfDates() {
      let dts = [];
      for (let i = this.max_dt; i >= this.min_dt; i = this.$moment(i * 1000).add(-1, 'hours').unix()) {
        dts.push({
          key: i,
          name: this.$moment(i * 1000).format('DD.MM.YYYY HH:mm'),
        })
      }
      return dts;
    },
    min_dt() {
      if (this.smogListData && this.smogListData.length > 0) {
        return this.$moment(this.max_dt * 1000).add(-23, 'hours').unix(); // na pevno -24hodin
      }
    },
    max_dt() {
      let max_dt = null;
      if (this.smogListData && this.smogListData.length > 0) {
        this.smogListData.forEach(item => {
          if (item.data.length > 0) {
            item.data.forEach(sub_item => {
              if (max_dt === null) max_dt = sub_item.dt;
              if (sub_item.dt > max_dt) max_dt = sub_item.dt;
            });
          }
        });
        return max_dt;
      }
    },
    smogListStations() {
      let res = [];
      if (this.smogListData && this.smogListData.length > 0) {
        this.smogListData.forEach(item => {
          let exists = res.find(inner => item.station.station_id === inner.station_id);
          if (!exists) res.push(item.station);
        });
      }
      return res;
    },
    smogListSHMUPollutants() {
      let res = [];
      this.smogListDataSHMU.forEach((v) => {
        v.station.pollutants.forEach(item => {
          let exists = res.find(inner => item.pollutant_id === inner.pollutant_id);
          if (!exists) res.push(item);
        });
        res.sort((a, b) => (a.order > b.order) ? 1 : -1)
      });
      return res;

    },
    smogListOthersPollutants() {
      let res = [];
      this.smogListDataOthers.forEach((v) => {
        v.station.pollutants.forEach(item => {
          let exists = res.find(inner => item.pollutant_id === inner.pollutant_id);
          if (!exists) res.push(item);
        });
        res.sort((a, b) => (a.order > b.order) ? 1 : -1)
      });
      return res;
    },
    smogListDataSHMU() {
      return this.smogListData.filter(item => item.station.type === 1);
    },
    smogListDataSHMUSorted() {
      const self = this;
      let r = [];
      if (this.smogListDataSHMU.length) {
        this.smogListDataSHMU.forEach(function (item) {
          let new_item = {};
          new_item['station_id'] = item.station.station_id;
          new_item['station_name'] = item.station.station_name;
          new_item['poradie'] = item.station.poradie;
          self.smogListSHMUPollutants.forEach(pollutant => {
            let item_x = self.fetchSmogDataItem(self.smogListDataSHMU, item.station.station_id, pollutant.pollutant_id);
            let val = -2;
            if (item_x) {
              if (item_x.value === null) val = -1;
              else if (item_x.value === 'PDL') val = 0;
              else val = parseFloat(item_x.value);
            } else {
              let poll = item.station.pollutants.find(inner => pollutant.pollutant_id === inner.pollutant_id);
              if (poll) val = -1.5;
            }

            new_item[pollutant.pollutant_id] = val;
          });

          r.push(new_item);
        });

      }

      if (r.length) {
        return r.sort((a, b) => {
          if (a[this.sortBy] > b[this.sortBy]) {
            return this.sortDir
          }
          return -this.sortDir;
        })
      }

      return [];

    },
    smogListDataOthersSorted() {
      const self = this;
      let r = [];
      if (this.smogListDataOthers.length) {
        this.smogListDataOthers.forEach(function (item) {
          let new_item = {};
          new_item['station_id'] = item.station.station_id;
          new_item['station_name'] = item.station.station_name;
          new_item['poradie'] = item.station.poradie;
          self.smogListOthersPollutants.forEach(pollutant => {
            let item_x = self.fetchSmogDataItem(self.smogListDataOthers, item.station.station_id, pollutant.pollutant_id);
            let val = -2;
            if (item_x) {
              if (item_x.value === null) val = -1;
              else if (item_x.value === 'PDL') val = 0;
              else val = parseFloat(item_x.value);
            } else {
              let poll = item.station.pollutants.find(inner => pollutant.pollutant_id === inner.pollutant_id);
              if (poll) val = -1.5;
            }

            new_item[pollutant.pollutant_id] = val;
          });

          r.push(new_item);
        });

      }

      if (r.length) {
        return r.sort((a, b) => {
          if (a[this.sortOhtersBy] > b[this.sortOhtersBy]) {
            return this.sortOthersDir;
          }
          return -this.sortOthersDir;
        })
      }

      return [];

    },
    smogListDataOthers() {
      return this.smogListData.filter(item => item.station.type === 2);
    },
    ttipStyle() {
      return {
        left: `${this.oLeft}px`,
        top: `${this.oTop}px`,
      }
    }



  },
  methods: {
    loadSmogListData: function() {
      const self = this;

      self.isLoading = true;
      self.errorMsg = null

      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getdata?history=24&station_meta=1&without_extras=1', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.smogListData = response.data;

              if (self.smogListData.length) {

                self.smogListDataLoaded = true;
                self.isError = false;
                self.errorMsg = null;

              } else {
                self.isError = true;
                self.smogListDataLoaded = false;
                self.errorMsg = 'Nastala chyba pri načítavaní údajov!';
              }

            } else {
              self.isError = true;
              if (response.data.error[0].text) {
                self.errorMsg = response.data.error[0].text;
              } else {
                self.errorMsg = 'Nastala chyba pri načítavaní údajov!';
              }

            }
            self.isLoading = false;

          }).catch((error) => {
        console.log(error);
        self.isError = true;
        self.errorMsg = 'Nastala chyba pri komunikácii so serverom!';
        self.isLoading = false;
      });

    },
    loadTooltipData: function() {
      const self = this;

      self.isTooltipLoading = true;
      self.errorMsg = null
      let station = self.lastTooltipParams.station_id;

      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getdata?history=168&station_meta=1&station=' + station, {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {

              if (response.data.length > 0) {
                self.$options.cachedFetch[station] = response.data[0];
                self.isTooltipLoading = false;
                self.tooltipErrorMsg = null;

              } else {
                self.tooltipErrorMsg = 'Nastala chyba pri načítavaní údajov! (1) ';
              }

            } else {
              if (response.data.error[0].text) {
                self.tooltipErrorMsg = response.data.error[0].text;
              } else {
                self.tooltipErrorMsg = 'Nastala chyba pri načítavaní údajov! (2)';
              }

            }
            self.isTooltipLoading = false;

          }).catch((error) => {
        console.log(error);
        self.tooltipErrorMsg = 'Nastala chyba pri komunikácii so serverom! (3)';
        self.isTooltipLoading = false;
      });

    },
    getSmogValueSHMU: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataSHMU, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && poll) return '*';
      }

      if (item === false) return '';
      if (item.value === null) return '*';
      return item.value;
    },
    getSmogLimitLevelSHMU: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataSHMU, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && !poll) return 'g';
      }

      if (item === false) return '';
      if (item.value === null) return 'w';
      if (typeof item.limit_level !== "undefined") {
        return item.limit_level;
      } else {
        return 'w';
      }
      return '';
    },
    getSmogLimitLevel: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListData, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && !poll) return 'g';
      }

      if (item === false) return '';
      if (item.value === null) return 'w';
      if (typeof item.limit_level !== "undefined") {
        return item.limit_level;
      } else {
        return 'w';
      }
      return '';
    },
    getSmogValueOthers: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataOthers, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && poll) return '*';
      }

      if (item === false) return '';
      if (item.value === null) return '*';
      return item.value;
    },
    getSmogLimitLevelOther: function(station_id, pollutant_id) {
      let item = this.fetchSmogDataItem(this.smogListDataOthers, station_id, pollutant_id);

      let station = this.smogListStations.find(inner => station_id === inner.station_id);
      if (station) {
        let poll = station.pollutants.find(inner => pollutant_id === inner.pollutant_id);
        if (item === false && !poll) return 'g';
      }

      if (item === false) return '';
      if (item.value === null) return 'w';
      if (typeof item.limit_level !== "undefined") {
        return item.limit_level;
      } else {
        return 'w';
      }
      return '';
    },
    fetchSmogDataItem: function(source, station_id, pollutant_id) {
      let st = source.find(item => item.station.station_id === station_id);
      if (!st) return false;
      if (st.data.length === 0) return '-';
      let data = st.data.find(item => item.dt === this.selectedDate && item.pollutant_id === pollutant_id);
      if (!data) return false;
      return data;
    },
    replacePollutantDesc: function(desc) {
      switch (desc) {
        case 'PM10': return 'PM<sub>10</sub>';
        case 'PM2.5': return 'PM<sub>2.5</sub>';
        case 'NO2': return 'NO<sub>2</sub>';
        case 'NOX': return 'NO<sub>X</sub>';
        case 'O3': return 'O<sub>3</sub>';
        case 'SO2': return 'SO<sub>2</sub>';
        default: return desc;
      }
    },
    prevDt() {
      if (this.selectedDate > this.min_dt) {
        this.selectedDate = this.$moment(this.selectedDate * 1000).add(-1, 'hours').unix()
      }
    },
    firstDt() {
      this.selectedDate = this.min_dt;
    },
    lastDt() {
      this.selectedDate = this.max_dt;
    },
    nextDt() {
      if (this.selectedDate < this.max_dt) {
        this.selectedDate = this.$moment(this.selectedDate * 1000).add(1, 'hours').unix()
      }
    },
    sorted(col) {
      if (col === this.sortBy) {
    //    return  ((this.sortDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>')
        return  ((this.sortDir === 1) ? 'sorting sorting_asc' : 'sorting sorting_desc')
      }
      return 'sorting';
    },
    do_sort(col) {
      this.sortBy = col;
      if (this.sortDir === 1) {
        this.sortDir = -1;
      } else {
        this.sortDir = 1;
      }

    },
    sorted_others(col) {
      if (col === this.sortOhtersBy) {
        return  ((this.sortOthersDir === 1) ? '<i class="icon-chevron-down"></i>' : '<i class="icon-chevron-up"></i>')
      }
      return '';
    },
    do_sort_others(col) {
      this.sortOhtersBy = col;
      if (this.sortOthersDir === 1) {
        this.sortOthersDir = -1;
      } else {
        this.sortOthersDir = 1;
      }

    },
    showTooltipDebounced: _.debounce(function( ...args ) {
      // console.log('debounced', ...args);
      this.showTooltip( ...args );
    }, 200),
    showTooltip(params) {
      const self = this;
      let ref_id = 'b_' + params.station_id + '_' + params.pollutant_id;
      let type = this.getSmogLimitLevel(params.station_id, params.pollutant_id)

      if (type !== 'g' && self.isOver) {
        let o = this.$refs[ref_id][0];
        let el_width = o.offsetWidth;
        let el_height = o.offsetHeight;
        let cl_width = document.documentElement.clientWidth;
        let cl_height = document.documentElement.clientHeight;

        let oParent;
        let oParentWidth;
        let topParentWidth;
        let topParentLeft;
        let oLeft = o.offsetLeft;
        while(o.offsetParent!=null) {
          oParent = o.offsetParent
          oLeft += oParent.offsetLeft
          o = oParent
        }

        o = this.$refs[ref_id][0];
        let oTop = o.offsetTop
        while(o.offsetParent!=null) { // Parse the parent hierarchy up to the document element
          oParent = o.offsetParent  // Get parent object reference
          oTop += oParent.offsetTop // Add parent top position
          o = oParent
        }

        let ttip_width = this.$refs.ttip.offsetWidth;
        let ttip_height = this.$refs.ttip.offsetHeight;

        let oldLeft = oLeft;
        let oldTop = oTop;

        oLeft += el_width + 5;
        oTop += el_height + 5;


        // console.log(oLeft, ttip_width, cl_width);

        if (oLeft + ttip_width + 100 >= cl_width) {
          oLeft = oLeft - ttip_width;
        }

        if (oTop + ttip_height + 25 >= cl_height) {
          oTop = oldTop - 5 - ttip_height;
        }

        this.oLeft = oLeft;
        this.oTop = oTop;

        self.lastTooltipParams = params;

        if (self.$options.cachedFetch[params.station_id]) {
           // console.log('mam', self.$options.cachedFetch[params.station_id])
        } else {
          self.loadTooltipData()
          // console.log('taham...', params.station_id);
        }

        // console.log('hover: ', type, ref_id, oldLeft, oLeft, oTop, cl_width, (oLeft + ttip_width));
      } else {
        // console.log('hover IGNORE: ', type, ref_id);
      }

    },
    hideTooltip() {
      // console.log('left');
      this.isOver = false;
      // this.lastTooltipParams = {};
      this.oLeft = -10000;
      this.oTop = -10000;

    }

  }
}
</script>

<style lang="scss">

.ko_oko_1 {
  background: #2e8540 !important;;
  color: white !important;
}
.ko_oko_0 {
  background: #20603c  !important;;
  color: white !important;
}
.ko_oko_2 {
  background: #ffef00  !important;;
  color: black !important;
}
.ko_oko_3 {
  background: #fdb81e !important;;
  color: black !important;
}
.ko_oko_4 {
  background: #cd2026 !important;;
  color: white !important;
}
.ko_oko_w {
  background: #ffffff !important;
  color: black !important;
}
.ko_oko_g {
  background: #e4e2e0 !important;
  color: black !important;
}

.v-ttip {
  position: absolute;
  border: 2px solid #aaaaaa;
  padding: 2px;
  min-width: 400px;
  min-height: 150px;
  background-color: white;
  z-index: 10000;
}




</style>
